"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useI18n } from "@/lib/i18n";
import { useEffect, useState } from "react";

export function Breadcrumb() {
  const path = usePathname();
  const parts = path.split("/").filter(Boolean);
  const { t } = useI18n();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const readVisibility = () => {
      try {
        const settings = JSON.parse(window.localStorage.getItem("nordlicht.appearance") || "null");
        setVisible(settings?.breadcrumbs ?? true);
      } catch {
        setVisible(true);
      }
    };
    readVisibility();
    window.addEventListener("nordlicht-appearance-change", readVisibility);
    return () => window.removeEventListener("nordlicht-appearance-change", readVisibility);
  }, []);

  if (!visible) return null;

  return (
    <nav className="text-sm text-gray-400 mb-2">
      <Link
        href="/"
        className="text-gray-500 hover:text-aurora-400 transition-colors"
      >
        {t("nav.home")}
      </Link>

      {parts.map((p, idx) => {
        const href = "/" + parts.slice(0, idx + 1).join("/");
        const isLast = idx === parts.length - 1;

        const routeLabels = {
          settings: t("settings.title"),
          profile: t("settings.profile"),
          appearance: t("settings.appearance"),
          notifications: t("settings.notifications"),
          cameras: t("user.cameras"),
          production: t("nav.production"),
          shipping: t("nav.shipping"),
        };
        const label = routeLabels[p] || p.replace(/-/g, " ").replace(/_/g, " ");
        const capitalized = label.charAt(0).toUpperCase() + label.slice(1);

        return (
          <span key={href}>
            {" / "}
            {isLast ? (
              <span className="text-gray-300">{capitalized}</span>
            ) : (
              <Link
                href={href}
                className="hover:text-aurora-400 transition-colors"
              >
                {capitalized}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
